import { Flex, Text } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import colors from "resources/theme/colors";
import { ClienteContrato } from "core/features/cliente/typings";

interface StatusContentRighProps {
  item?: ClienteContrato;
}

export default function StatusContentRight({ item }: StatusContentRighProps) {
  const textStatus = item?.ativo ? "Ativo" : "Encerrado";
  const colorStatus = item?.ativo ? colors.green : colors.gray;
  return (
    <Flex mb={4} w="100%">
      <Flex
        flex={4}
        h="20px"
        w="2px"
        align="center"
        borderLeft={`solid 3px ${colorStatus}`}
        pl={1}
      >
        <Text>{textStatus}</Text>
      </Flex>
      <Flex fontSize="16px" fontWeight="bold">
        {formatMoney(item?.valor)}
      </Flex>
    </Flex>
  );
}
